import { ValueFormatterFunc } from '@ag-grid-community/core';
import { DateTime } from 'luxon';

export const filterTypeMapping = {
  equals: 'EQUALS',
  notEqual: 'NOT_EQUALS',
  greaterThan: 'GREATER_THAN',
  greaterThanOrEqual: 'GREATER_THAN_OR_EQUALS',
  lessThan: 'LESS_THAN',
  lessThanOrEqual: 'LESS_THAN_OR_EQUALS',
  contains: 'CONTAINS',
  notContains: 'NOT_CONTAINS',
  startsWith: 'STARTS_WITH',
  endsWith: 'ENDS_WITH',
  blank: 'BLANK',
  notBlank: 'NOT_BLANK',
  inRange: 'IN_RANGE',
  set: 'EQUALS',
};

export const transformFilters = (inputFilters: { [key: string]: unknown }) => {
  const outputFilters = Object.keys(inputFilters).map((key) => {
    const filter = inputFilters[key] as {
      filterType: string;
      type: keyof typeof filterTypeMapping;
      filter: string;
      dateFrom?: string | null;
      dateTo?: string | null;
      values?: string[];
    };
    if ((filter as { filterType: string }).filterType === 'date') {
      const dateFilters = [];

      if (Boolean(filter.dateFrom)) {
        dateFilters.push(
          DateTime.fromFormat(
            filter.dateFrom as string,
            'yyyy-MM-dd HH:mm:ss',
          ).toFormat('MM/dd/yyyy'),
        );
      }

      if (Boolean(filter.dateTo)) {
        dateFilters.push(
          DateTime.fromFormat(
            filter.dateTo as string,
            'yyyy-MM-dd HH:mm:ss',
          ).toFormat('MM/dd/yyyy'),
        );
      }
      return {
        field: key,
        filterType:
          filterTypeMapping[
            (filter as { type: keyof typeof filterTypeMapping }).type
          ],
        values: dateFilters,
      };
    }
    if ((filter as { filterType: string }).filterType === 'set') {
      return (
        (filter.values ?? []).length > 0 && {
          field: key,
          filterType: 'IN',
          values: filter.values,
        }
      );
    }
    if ((filter as { filterType: string }).filterType === 'text') {
      return {
        field: key,
        filterType:
          filterTypeMapping[
            (filter as { type: keyof typeof filterTypeMapping }).type
          ],
        values: [(filter as { filter: string }).filter],
      };
    }
  });

  return outputFilters.filter(Boolean);
};

export const shortMonthDateFormatterCallingQueue: ValueFormatterFunc<
  unknown,
  Date
> = (param) => {
  let date = param.value;
  if (date === undefined || date === null) return '';
  date = new Date(date);
  if (date.toString() === 'Invalid Date') return '';
  return DateTime.fromJSDate(date).toFormat('MMM d, yyyy HH:mm');
};
